<script src="../../../vue.config.js"></script>
<template>
    <div class="enlightenment-course">
        <div class="course-header">
            <div class="course-content">
                <div class="qtz-course"><img src="../../assets/imgs/course/enlightenment-course-title-icon.png" alt="">专项能力课-科学启蒙课</div>
                <ul class="course-detail">
                    <li>在孩子的科学思维启蒙阶段，通过想象和闪卡等七田真特色教学法，</li>
                    <li>输入科学知识，培养逻辑、归纳及辩证的科学思维和求真的科学态度。</li>
                </ul>
            </div>
        </div>
        <div class="course-content">
            <img src="../../assets/imgs/course/enlightenment-course-1.png" alt="">
        </div>
        <div style="text-align: right;background: #fff">
            <img src="../../assets/imgs/course/enlightenment-course-2.png" alt="">
        </div>
        <div class="course-content">
            <div class="course-content max-title" style="margin-bottom:0;border-bottom: none">
                <span>课程展示</span>
                <span>Experiments in science class</span>
            </div>
            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">三原色实验</button>
                </div>
            </div>

            <ul class="list-text">
                <li>了解三原色基本构成;探索颜色的变化和分解,激发孩子兴趣;</li>
                <li>通过实验操作,培养实事求是的科学精神。</li>
            </ul>

            <ul class="list-text">
                <li style="display: flex;justify-content: space-between;">
                    <img src="../../assets/imgs/course/enlightenment-course-3.png" alt="">
                    <img src="../../assets/imgs/course/enlightenment-course-4.png" alt="">
                    <img src="../../assets/imgs/course/enlightenment-course-5.png" alt="">
                </li>
                <li>
                    <img style="display: block;margin: 0 auto;" src="../../assets/imgs/course/enlightenment-course-6.png" alt="">
                </li>
            </ul>

            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">认知磁性</button>
                </div>
            </div>

            <ul class="list-text" style="display: flex;justify-content: space-between;align-items: center">
                <li>
                    磁铁:认识常见的条形、蹄形、圆形磁铁,通过实验发现磁铁的磁力、磁极、磁场三种属性,培养孩子有条不素的操作习惯。
                </li>
                <li style="margin-left: 40px">
                    <img style="display: block;margin: 0 auto;" src="../../assets/imgs/course/enlightenment-course-7.png" alt="">
                </li>
            </ul>

            <ul class="list-text">
                <li style="display: flex;justify-content: space-between;">
                    <img src="../../assets/imgs/course/enlightenment-course-8.png" alt="">
                    <img src="../../assets/imgs/course/enlightenment-course-9.png" alt="">
                    <img src="../../assets/imgs/course/enlightenment-course-10.png" alt="">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "enlightenment-course",
        data(){
            return {

            }
        }
    }
</script>

<style scoped lang="less">
    .enlightenment-course{
        background: #fff;
        .course-header{
            background-image: url("../../assets/imgs/course/memory-course-bg.png");
        }
        .content-item{
            border-top: 1px solid #F8B300;
        }
        .page-btn{
            background: #F8B300;
        }
        .max-title{
            color: #F8B300;
            border-bottom: 1px solid #F8B300;
        }
        .list-text{
            margin: 30px 0;
            color: #6A6767;
            font-size: 16px;
            font-family: Light;
            li{
                img{
                    margin-right: 15px;
                }
            }
        }
    }
</style>
